import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-home-hero',
    templateUrl: './home-hero.component.html',
    styleUrls: ['./home-hero.component.scss'],
    imports: [RouterLink, CtrlIconComponent],
})
export class HomeHeroComponent {}
